module.exports = __webpack_public_path__ + "img/Mage-human-m-70.f609fe77.gif";